import { render, staticRenderFns } from "./ProductsOnOfferComboCards.vue?vue&type=template&id=6175ae08&scoped=true"
import script from "./ProductsOnOfferComboCards.vue?vue&type=script&lang=js"
export * from "./ProductsOnOfferComboCards.vue?vue&type=script&lang=js"
import style0 from "./ProductsOnOfferComboCards.vue?vue&type=style&index=0&id=6175ae08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6175ae08",
  null
  
)

export default component.exports